












import Vue from 'vue';
import { createScore, Score } from '@/game/model';

export default Vue.component('Score', {
  props: ['score'],
  computed: {
    pieces() {
      const score = this.$props.score as Score || createScore();
      return [
        ...(score.black ? Array(score.black).fill('black') : []),
        ...(score.white ? Array(score.white).fill('white') : []),
        ...(score.black + score.white < 4 ? Array(4 - score.black - score.white).fill(undefined) : [])
      ];
    }
  }
});
